<template>
    <div>
        <p class="mb-3 text-center">
            <slot name="labelText">{{ translate('Total file size per conversion') }}:</slot>
        </p>
        <div class="px-5 pb-4">
            <VueSlider
                :adsorb="true"
                :clickable="true"
                :drag-on-click="true"
                :disabled="disabled"
                tooltip="none"
                :marks="getMark"
                :data="['200', '400', '1000', '2000', '4000', '8000']"
                ref="sizeSlider"
                :key="selectedBilling + sliderKey"
                v-model="selectedSize"
                :process="getProcess"
                :duration="0"
            ></VueSlider>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { pageStoreMixin } from '../../../../store/page-store';

export default {
    name: 'SelectFileSizeSlider',
    components: { VueSlider },
    mixins: [TransFilter, pageStoreMixin],
    props: {
        isDayBillingSelected: {
            type: Boolean,
            required: true,
        },
        selectableSizes: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '200',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        selectedBilling() {
            return this.store.userPaymentModal.selectedBilling;
        },
    },
    watch: {
        selectedSize(size, oldSize) {
            const sizeInt = Number.parseInt(size);
            if (!this.isDayBillingSelected || sizeInt >= 1000) {
                if (size === oldSize) {
                    // no need to emit event if the value didn't change
                    return;
                }

                this.$emit('input', size);

                return;
            }

            // if user selected the 24h pass we don't want to allow them to select a conversion size below 1GB

            // force set selected size
            this.selectedSize = '1000';

            // force vue to re-render the slider
            // (otherwise the ui will not match the internal data here)
            this.sliderKey++;
        },
        isDayBillingSelected(isDay) {
            if (!isDay) {
                return;
            }

            // if user selected the 24h pass we need to make sure that the selected conversion size is not below 1GB

            const sizeInt = Number.parseInt(this.selectedSize);
            if (sizeInt >= 1000) {
                return;
            }

            // force set selected size
            this.selectedSize = '1000';

            // force vue to re-render the slider
            // (otherwise the ui will not match the internal data here)
            this.sliderKey++;
        },
    },
    methods: {
        getProcess(dotsPos) {
            if (!this.isDayBillingSelected) {
                return [[0, dotsPos[0], { backgroundColor: '#4285f4' }]];
            }

            return [
                [0, 40, { backgroundColor: '#e1e1e1' }],
                [40, dotsPos[0], { backgroundColor: '#4285f4' }],
            ];
        },
        getMark(size) {
            if (!this.selectableSizes[size]) {
                return { label: '' };
            }

            const mark = {
                label: this.selectableSizes[size],
            };

            const sizeInt = Number.parseInt(size);

            if (this.isDayBillingSelected && sizeInt < 1000) {
                mark.labelStyle = {
                    color: '#e1e1e1',
                };
            }

            return mark;
        },
    },
    data() {
        return {
            sliderKey: 0,
            selectedSize: this.value,
        };
    },
};
</script>
